export default {
  items: [
    {
      color: 'primaryConst',
      subColor: "#758AFE",
      icon: 'mdi-navigation',
      iconSize: '16',
      opposite: 'yesterday<h5>8:03 pm</h5>',
      title: 'Jessica Nilson',
      avatar: require('@/assets/img/time-line/a1.jpg'),
      nick: '@jess',
      subtitle: '10:12 am - Publicly near Minsk',
      content: {
        googleMap: true,
        image: false,
        text: null
      },
      comments: [
        {
          divider: true,
          id: 1,
          avatar: require('@/assets/img/time-line/a1.jpg'),
          title: '<a>Jessica Nilson</a> <small>7 mins ago</small>',
          subtitle: 'Someone said they were the best people out there just few years ago. Don\'t know better options.'
        },
        {
          divider: true,
          id: 2,
          avatar: require('@/assets/img/time-line/a2.jpg'),
          title: '<a>Jessica Nilson</a> <small>7 mins ago</small>',
          subtitle: 'Someone said they were the best people out there just few years ago. Don\'t know better options.'
        },
      ]
    },
    {
      color: 'secondary',
      subColor: "#FE90B7",
      icon: 'mdi-message',
      iconSize: '16',
      opposite: 'yesterday<h5>8:03 pm</h5>',
      title: 'Jessica Nilson',
      avatar: require('@/assets/img/time-line/a2.jpg'),
      nick: '@jess',
      subtitle: '10:12 am - Publicly near Minsk',
      content: {
        googleMap: false,
        image: false,
        text: 'There is no such thing as maturity. There is instead an ever-evolving process of maturing. Because when there is a maturity, there is ...'
      }
    },
    {
      color: 'warning',
      subColor: "#FFCE80",
      icon: 'mdi-coffee',
      iconSize: '16',
      opposite: 'yesterday<h5>8:03 pm</h5>',
      title: 'Jessica Nilson',
      avatar: require('@/assets/img/time-line/a3.jpg'),
      nick: '@jess',
      subtitle: '10:12 am - Publicly near Minsk',
      content: {
        googleMap: false,
        image: true,
        text: 'Check out this awesome photo I made in Italy last summer. Seems it was lost somewhere deep inside my brand new HDD 40TB. Thanks god I found it!'
      },
      comments: [
        {
          divider: true,
          id: 1,
          avatar: require('@/assets/img/time-line/a3.jpg'),
          title: '<a>Jessica Nilson</a> <small>7 mins ago</small>',
          subtitle: 'Someone said they were the best people out there just few years ago. Don\'t know better options.'
        },
      ]
    },
    {
      color: 'success',
      subColor: "#63DDB3",
      icon: 'mdi-alpha-j',
      iconSize: '28',
      opposite: 'yesterday<h5>8:03 pm</h5>',
      title: 'Jessica Nilson',
      avatar: require('@/assets/img/time-line/a4.jpg'),
      nick: '@jess',
      subtitle: '10:12 am - Publicly near Minsk',
      content: {
        googleMap: false,
        image: false,
        text: 'Let\'s try something different this time. Hey, do you wanna join us tonight? We\'re planning to a launch a new project soon. Want to discuss with all of you...'
      }
    },
  ]
}
